import { Skeleton } from '@mui/material';
import React from 'react';

const SkeletonEvents = () => {
  return (
    <>
      <div >
        <Skeleton
          variant='rectangular'
          sx={{ bgcolor: 'grey.900', width: 150, borderRadius: '20px', height: 146 }}
        />
         
      </div>
   
    </>
  );
};

export default SkeletonEvents;

